import React, { Component } from "react";

export default class PageInstagramWall extends Component {
  	
	render () {
		
		let block = this.props.block;
									
		let blockClass = 'c-page__block c-page__block--load-effect';
						
		if (block.data) {
			
			const data = JSON.parse(block.data).data;
			
			console.log(data);
								
		    return (
			    
				<div id={block.id} className={blockClass}>
				    			    		
			    	<div className="l-grid">
			    		
			    		<div className="l-grid__col">
			    					    			
				    		<div className="scope-instagram">
				    						    			
				    			{data.map((item,i) =>
									{
										if (item.media_url.indexOf('.mp4') === -1) {
											return (
												<a href={item.permalink} key={i}>
													<img src={item.media_url} />
													<p dangerouslySetInnerHTML={{__html:item.caption}}></p
												></a>
											)
										} else {
											return null;
										}
									}
								)}
																
				    		</div>
				    					    					    			
			    		</div>
			   			    					    
				    </div>
				    
				</div>
				
			)
		
		} else {
			
			return null
			
		}
			
	}
}
